import * as React from 'react'

import { Table } from '../table/Table'
import { useDataTable } from './DataTableContext'
import { DataTableRow } from './DataTableRow'

type DataTableBodyProps = Omit<
  React.ComponentProps<typeof Table.Body>,
  'children'
> & {
  rowAction?: (row: Record<string, unknown>, event: React.MouseEvent) => void
}

export const DataTableBody = ({
  striped = false,
  rowAction,
  ...props
}: DataTableBodyProps) => {
  const { getRowModel } = useDataTable()

  return (
    <Table.Body {...props} striped={striped}>
      {getRowModel().rows.map((row) => {
        return <DataTableRow row={row} key={row.id} rowAction={rowAction} />
      })}
    </Table.Body>
  )
}
